import {getDistanceInKM, raf} from "./util";

const infoWindows = [];
const distanceBeforeMergeInKM = 2;
const zoomToShowAll = 13;

export function registerGoogleMaps() {
    raf(() => Array.prototype.slice.call(document.querySelectorAll("div.google-map")).forEach(el => initializeGoogleMap(el)));
}

function initializeGoogleMap(el) {
    const lat = parseFloat(el.dataset.lat || 25);
    const lng = parseFloat(el.dataset.lng || 0);
    const zoom = parseFloat(el.dataset.zoom || 3);
    const disableUI = el.dataset.disableUi === "true";
    const icon = el.dataset.icon || null;
    const highlightIcon = el.dataset.highlightIcon || null;
    const iconZoomer = el.dataset.iconZoomer || null;

    let infoWindowMarkup = el.dataset.infoWindow || null;
    let markers = el.dataset.markers || null;

    const options = {
        center: {lat, lng},
        zoom,
        scrollWheel: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    if (disableUI) {
        options.disableDefaultUI = true;
        options.scrollWheel = false;
        options.navigationControl = false;
        options.mapTypeControl = false;
        options.scaleControl = false;
        options.draggable = false;
    }

    const googleMap = new google.maps.Map(el, options);
    googleMap.setOptions({scrollwheel: options.scrollWheel});

    if (markers === null || typeof window[markers] === "undefined") {
        const markerOptions = {
            position: {lat, lng},
            title: "Marker"
        };

        if (icon !== null)
            markerOptions.icon = icon;

        const marker = new google.maps.Marker(markerOptions);
        marker.setMap(googleMap);
    } else if (typeof window[markers] !== "undefined") {
        markers = window[markers];

        const addedMarkers = [];

        for (let marker of markers) {
            const markerOptions = {
                animation: google.maps.Animation.DROP,
                position: {
                    lat: marker.position[0],
                    lng: marker.position[1]
                },
                title: marker.name
            };

            if (icon !== null)
                markerOptions.icon = icon;

            const m = new google.maps.Marker(markerOptions);
            m.linkedMarkers = [];
            m.setMap(googleMap);

            for (let otherMarker of addedMarkers) {
                const ap = otherMarker.getPosition();
                const pa = {lat: ap.lat(), lng: ap.lng()};
                const pb = {lat: marker.position[0], lng: marker.position[1]};
                const distance = getDistanceInKM(pa, pb);

                if (distance < distanceBeforeMergeInKM) {
                    otherMarker.linkedMarkers.push(m);
                    otherMarker.setIcon(iconZoomer);

                    m.setAnimation(null);
                    m.setMap(null);

                    zoomMarkerListener(googleMap, otherMarker, icon, iconZoomer);
                }
            }

            if (typeof window[infoWindowMarkup] !== "undefined") {
                let contentString = window[infoWindowMarkup];
                const windowData = marker.info_window || {};

                for (let k in windowData) {
                    if (!windowData.hasOwnProperty(k))
                        continue;

                    const key = `{% ${k} %}`;
                    const value = windowData[k];

                    contentString = contentString.replace(new RegExp(key, 'g'), value);
                }

                const index = infoWindows.length;

                infoWindows[index] = new google.maps.InfoWindow({content: contentString});

                m.index = index;
                m.marker = marker;

                m.addListener("click", onMarkerClickForInfoWindow);
            }

            if (m.getMap() !== null)
                addedMarkers.push(m);
        }
    }

    if (window.originMarker) {
        const markerOptions = {
            position: {lat: originMarker.lat, lng: originMarker.lng},
            title: originMarker.name,
            icon: highlightIcon || "",
            zIndex: 99999999
        };

        const marker = new google.maps.Marker(markerOptions);
        marker.setMap(googleMap);
    }
}

export function onMarkerClickForInfoWindow() {
    const linked = this.linkedMarkers;
    const map = this.getMap();

    if (linked.length > 0 && map.getZoom() < zoomToShowAll) {
        map.setZoom(zoomToShowAll);
        map.panTo(this.getPosition());
    } else {
        for (let infoWindow of infoWindows)
            infoWindow.close();

        infoWindows[this.index].open(map, this);
    }
}

export function zoomMarkerListener(map, marker, icon, iconZoomer) {
    map.addListener("zoom_changed", () => {
        const linked = marker.linkedMarkers;
        const zoom = map.getZoom();
        let showMarkers = zoom >= zoomToShowAll;

        marker.setIcon(showMarkers ? icon : iconZoomer);

        for (let link of linked)
            link.setMap(showMarkers ? map : null);
    });
}
